import React from 'react';
import { CallbackComponent } from 'redux-oidc';

import { Loading } from '_components';
import { session, history } from '_helpers';

const CallbackPage = () => (
  <CallbackComponent
    userManager={session.userManager}
    successCallback={(user) => {
      history.push(user?.state?.entities?.path || '/');
    }}
    errorCallback={(error) => {
      history.push('/');
      console.error('errorCallback', error);
    }}
  >
    <Loading fullscreen />
  </CallbackComponent>
);

export default CallbackPage;
